document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-cr-row]').forEach(function (row) {
    var track = row.querySelector('[data-cr-track]');
    var prev = row.querySelector('[data-cr-prev]');
    var next = row.querySelector('[data-cr-next]');
    if (!track) return;

    function step() {
      var item = track.querySelector(':scope > *');
      if (!item) return track.clientWidth * 0.8;
      var style = window.getComputedStyle(track);
      var gap = parseFloat(style.columnGap || style.gap || '16');
      return item.getBoundingClientRect().width + gap;
    }

    if (prev) {
      prev.addEventListener('click', function () {
        track.scrollBy({ left: -step(), behavior: 'smooth' });
      });
    }
    if (next) {
      next.addEventListener('click', function () {
        track.scrollBy({ left: step(), behavior: 'smooth' });
      });
    }

    var dragging = false;
    var startX = 0;
    var startScroll = 0;
    var moved = false;

    track.addEventListener('pointerdown', function (e) {
      dragging = true;
      moved = false;
      track.classList.add('is-dragging');
      startX = e.clientX;
      startScroll = track.scrollLeft;
      track.setPointerCapture(e.pointerId);
    });

    track.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      var delta = e.clientX - startX;
      if (Math.abs(delta) > 3) moved = true;
      track.scrollLeft = startScroll - delta;
    });

    function endDrag() {
      dragging = false;
      track.classList.remove('is-dragging');
    }
    track.addEventListener('pointerup', endDrag);
    track.addEventListener('pointercancel', endDrag);

    track.addEventListener(
      'click',
      function (e) {
        if (moved) {
          e.preventDefault();
          e.stopPropagation();
        }
      },
      true
    );
  });
});
